import 'slick-carousel'
import GET_CATEGORIES from '../plugins/getCategories'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const slider = {
  obj:'.block-brand__slider',
  init() {
    $(this.obj).slick({
      autoplay: true,
      variableWidth: true,
      fade: false,
      dots: false,
      arrows: false,
      speed: 7500,
      autoplaySpeed: 0,
      cssEase: 'linear',
      easing: 'linear'
    })
  }
}

const init = () => {

    //mainvisual キャッチにクラス付与
    Promise.all([ w.load['mainvisual'] ]).then( () => {
      $('.mainvisual__catch').addClass('is-start')
    })

    // news
    $.when( w.load['block-news'] ).then( () => {
      let makeItem = item => $(`
        <a class="block-news-item" href="${item.href}">
          <figure class="block-news-item__img">
            <div class="block-news-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="110" loading="lazy"></div>
          </figure>
          <div class="block-news-item__body">
            <span class="date-cate">${item.date}&nbsp;|&nbsp;${item.category.name}</span>
            <span class="subject">${item.title.str_truncate(24)}</span>
            <span class="desc">${item.desc.str_truncate(30)}</span>
          </div>
        </a>
      `)[0]
      GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })

      // カテゴリ一覧取得
      GET_CATEGORIES(`.block-news__catList[data-plugin="getCategories"]`)
    })



    // slick実行
    $.when( w.load['block-brand'] ).then( () => {
      let makeItem = item => $(`
        <li class="block-brand__item">
          <a href="/brand/#brand-${item.id}">
            <img src="${item.thumb}" alt="${item.title}" loading="lazy">
          </a>
        </li>
      `)[0]
      GET_ARTICLES('.block-brand__slider[data-plugin="getArticles"]', { makeItem }).then( () => {
        slider.init()
      })
    })

}


export default function HOME() {
  $( init )
}